import React, { useEffect } from "react";
import {
	useParams,
	useLocation,
	useNavigate,
	Navigate,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSubheaderText } from "../actions/navigateActions";

/*
	paramValidation: object mapping param names to validation rules.
	- Array of strings: param must be one of these values
	- RegExp: param must match the pattern
	Example: { id: /^\d+$/, root: ["public", "private"] }
	If validation fails, redirects to /.
*/
function RouteElement({
	component: Component,
	subheaderText,
	subheaderIconName,
	splatParamName,
	staticParams,
	paramValidation,
	...rest
}) {
	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const resolvedParams = { ...params, ...staticParams };
	if (splatParamName && params["*"] !== undefined) {
		resolvedParams[splatParamName] = params["*"];
	}

	let validationFailed = false;
	if (paramValidation) {
		for (const [paramName, rule] of Object.entries(paramValidation)) {
			const value = resolvedParams[paramName];
			if (Array.isArray(rule)) {
				if (!rule.includes(value)) {
					validationFailed = true;
					break;
				}
			} else if (rule instanceof RegExp) {
				if (!rule.test(value)) {
					validationFailed = true;
					break;
				}
			}
		}
	}

	const history = {
		push: navigate,
		replace: (to, options) => navigate(to, { ...options, replace: true }),
		goBack: () => navigate(-1),
		block: () => {
			console.warn(
				"history.block is not supported in v6. Use useBlocker hook."
			);
			return () => {};
		},
		location,
		length: window.history.length,
	};
	const match = { params: resolvedParams };

	useEffect(() => {
		if (subheaderText) {
			dispatch(
				setSubheaderText({
					subheaderText,
					subheaderIconName: subheaderIconName || null,
				})
			);
		}
	}, [subheaderText, subheaderIconName, dispatch]);

	if (validationFailed) {
		return <Navigate to="/" replace />;
	}

	return (
		<Component
			{...rest}
			match={match}
			history={history}
			location={location}
		/>
	);
}

export default RouteElement;
